import { HomeInvitePage } from './HomeInvitePage';
export default HomeInvitePage;
